module.exports = __webpack_public_path__ + "assets/img/btn-back-057e6f4b.png";